import { useState } from "react";
// import { Truck, Shield, Award, Star } from "lucide-react";
import Booking from "./Booking";
import CallModal from "./Call";
import { Helmet } from "react-helmet";
import "../styles/HeroSection.css";

function HeroSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCallModalOpen, setIsCallModalOpen] = useState(false);

  return (
    <section
      className="hero-section"
      id="hero-section"
      role="banner"
      aria-label="Lu - Fit Hero Section"
      itemScope
      itemType="https://schema.org/LocalBusiness"
    >
      <Helmet>
        <title>Lu - Fit | Cape Town Personal Training for Real Results</title>
        <meta
          name="description"
          content="Transform your body and mindset with Lu - Fit — certified personal training based in Cape Town. Book a free intro session today!"
        />
      </Helmet>

      <meta itemProp="name" content="Lu - Fit Personal Training" />
      <meta itemProp="address" content="Cape Town, Western Cape, South Africa" />
      <meta itemProp="telephone" content="+27-XXX-XXX-XXXX" />

      <div className="container">
        <div className="hero-grid">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Personalized <span className="highlight">Fitness Coaching</span> in Cape Town
              </h1>
              <p className="hero-description">
                One-on-one personal training tailored to your body, schedule, and goals. Work with a certified trainer
                who meets you where you are.
              </p>
            </div>
            <div className="hero-buttons" role="group" aria-label="Call to action buttons">
              <a href="#" onClick={() => setIsCallModalOpen(true)}>
                <button className="btn primary" aria-label="Call Lu - Fit now">
                  Call Now
                </button>
              </a>
              <a href="#" onClick={() => setIsModalOpen(true)}>
                <button className="btn outline" aria-label="Book a training session now">
                  Book Now
                </button>
              </a>
            </div>
            <div className="hero-benefits">
              <div className="benefit-item">
                <img 
                  className="benefit-icon"
                  src="/media/icons/mobile-phone-icon.png"
                  alt="image of a star icon"
                  loading="lazy" 
                />
                <span>Mobile Sessions Available</span>
              </div>
              <div className="benefit-item">
                <img 
                  className="benefit-icon"
                  src="/media/icons/certified-icon.png"
                  alt="image of a star icon"
                  loading="lazy" 
                />
                <span>Certified & Insured</span>
              </div>
              <div className="benefit-item">
                <img 
                  className="benefit-icon"
                  src="/media/icons/thumbs-up.png"
                  alt="image of a star icon"
                  loading="lazy" 
                />
                <span>Proven Results</span>
              </div>
            </div>
          </div>

          <div className="hero-image-container">
            <img
              src="/media/hero-section/IMG-20231021-WA0002-529x705.jpg"
              alt="Image of Lumu your personal trainer sitting on a gym weight bench"
              className="hero-image"
              loading="lazy"
            />
            <div className="customer-card">
              <div className="customer-info">
                <div className="customer-avatars">
                  {[1, 2, 3].map((i) => (
                    <img
                      key={i}
                      src="/media/icons/user-avatar.png"
                      alt="Client testimonial avatar"
                      className="avatar"
                      loading="lazy"
                    />
                  ))}
                </div>
                <div>
                  <div className="star-rating">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <img 
                        key={star}
                        src="/media/icons/star-icon.png"
                        alt="image of a star icon"
                        loading="lazy"
                        className="star-icon" 
                      />
                    ))}
                  </div>
                  <p className="customer-note">500+ Happy Clients Trained</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Booking isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
      <CallModal isOpen={isCallModalOpen} setIsOpen={setIsCallModalOpen} />
    </section>
  );
}

export default HeroSection;
